import codenamesGame from "../../games/codenames/gameDefinition";
import tabooGame from "../../games/taboo/gameDefinition";

export const registeredGames = [codenamesGame, tabooGame];

export const defaultGameDefinition = registeredGames[0];

export function getGameBySlug(gameSlug) {
  return registeredGames.find((game) => game.slug === gameSlug);
}
